import { GeoJsonLayer } from "@deck.gl/layers";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { AIS_URL } from "../../services/pallas";
import ShipIcon from "../../icons/fishing-boat.png";
import AIS_SNAPSHOT from './ais_snapshot.json';

export type Vessel = { properties: { mmsi: number, name: string }, geometry: { coordinates: [number, number] } }

export function useAISLayer(visible: boolean): [GeoJsonLayer<Vessel>, { [key: string]: Vessel }] {

  const aisShipMap = useRef<{ [key: string]: Vessel }>(
    useMemo(() => AIS_SNAPSHOT as any, [])
  );
  const [, updateState] = useState<{}>();
  const forceUpdate = useCallback(() => updateState({}), []);

  useEffect(() => {
    if (!visible)
      return;

    const aisEventSource = new EventSource(AIS_URL);

    aisEventSource.addEventListener('message', (event) => {
      const aisData = JSON.parse(event.data);
      aisShipMap.current[aisData.properties.mmsi] = aisData;
    });

    // AIS updates arrive very frequently, DeckGL starts to stutter if we recompute the layer on every update.
    // So instead we trigger a render every N seconds:
    const interval = setInterval(() => {
      forceUpdate();
    }, 2000);

    return () => {
      aisEventSource.close();
      clearInterval(interval);
    };
  }, [forceUpdate, visible]);

  return [new GeoJsonLayer({
    id: 'ais_vessels',
    data: Object.values(aisShipMap.current),
    pickable: true,
    autoHighlight: true,
    pointType: 'icon',
    getIcon: () => ({ id: "ShipIcon", url: ShipIcon, width: 192, height: 148 }),
    iconSizeMaxPixels: 40,
    // iconSizeMinPixels: 22,
    iconSizeUnits: "common",
    getIconSize: 0.6,
    // iconBillboard: false,
    highlightColor: [100, 100, 100, 180],
    getIconColor: [0, 0, 0, 255],
    parameters: {
      depthTest: false
    },
    visible
  }), aisShipMap.current]
}
